/** 停止生成后，把刚发出的用户话回填到输入区（不覆盖进行中草稿）。 */

import type { PickRefPageContext } from "@/lib/brand-site-pick-refs";
import type { PickRefComposerContent } from "@/lib/pick-ref-mixed-editor";

export type HermesStopRestoreTarget =
  | { kind: "none" }
  | { kind: "textarea"; text: string }
  | { kind: "mixed"; content: PickRefComposerContent };

export function plainTextToComposerContent(
  text: string,
  page: PickRefPageContext = { pageSlug: "", pagePath: "", pageTitle: null },
): PickRefComposerContent {
  return {
    ...page,
    segments: [{ type: "text", text }],
    picks: [],
    userRequest: text,
  };
}

export function resolveHermesStopRestore(opts: {
  restore: string | null;
  draftEmpty: boolean;
  studioActive: boolean;
  lastComposer: PickRefComposerContent | null;
}): HermesStopRestoreTarget {
  if (opts.restore == null || !opts.draftEmpty) return { kind: "none" };

  if (opts.studioActive) {
    const prior = opts.lastComposer;
    if (prior && (prior.picks.length > 0 || prior.userRequest.trim())) {
      return { kind: "mixed", content: prior };
    }
    return { kind: "mixed", content: plainTextToComposerContent(opts.restore) };
  }

  return { kind: "textarea", text: opts.restore };
}
